import React, { Component } from 'react';

const containerStyle = {
  width: '100%',
  overflow: 'hidden',
  position: 'relative'
}

export default class Carousel extends Component {
  constructor(props){
    super(props)
    this.transitionDelay = 300
    this.state = {
      slides: props.children || Array(1).fill(null),
      previousIndexShown: 0,
      indexShown:0,
      isTransitioning: false
    }

  }

  componentWillReceiveProps(nextProps){
    if(nextProps.children)
      this.setState({slides: nextProps.children || [], indexShown: 0})
  }

  slideStyle = (s,i,a) =>{
    let translate = (i - this.state.indexShown)*100 + '%';
    return {
      top:'0px',
      width: '100%',
      transition: `transform ${this.transitionDelay}ms ease-in-out`,
      transform: `translate(${translate},0)`,
      position: i === this.state.indexShown ? 'relative': 'absolute'
    }
  }

  advance = ()=>{
    if(this.state.indexShown === this.state.slides.length - 1)
      return false
    this.goToIndex(this.state.indexShown + 1)
  }

  retreat = () =>{
    if(this.state.indexShown === 0)
      return false
    this.goToIndex(this.state.indexShown - 1)
  }

  reset = () =>{
    setTimeout(()=>{
      this.setState({previousIndexShown: this.state.indexShown})
    },this.transitionDelay)
  }

  goToIndex= (k) =>{
    this.setState({indexShown:k,
     previousIndexShown: this.state.indexShown}, this.reset)
  }

  render(){ //REQUIRED
    if(typeof this.state.slides.length === 'undefined')
      return <div>{this.state.slides}</div>
    return (
      <div style={{position:'relative',paddingTop:this.props.paddingTop || '49px'}} className='gnm-carousel'>
        <ol className="carousel-indicators">
          {Array(this.state.slides.length).fill(null).map((s,i,a)=>{
            return <li key={i} className={i=== this.state.indexShown ? 'active' : ''} onClick={()=>{this.goToIndex(i)}}></li>
          })}
        </ol>
        <span className={'left-control ' + (this.state.indexShown > 0 ? '' : 'inactive') } onClick={this.retreat}>{this.props.leftControl || null}</span>
        <span className={'right-control ' + (this.state.indexShown < this.state.slides.length - 1 ? '' : 'inactive')}  onClick={this.advance}>{this.props.rightControl || null}</span>

        <div style={containerStyle} >
          {this.state.slides.map((s,i,a)=>{
              return <div key={i} style={this.slideStyle(s,i,a)}>{s}</div>
            })
          }
        </div>
      </div>



    )
  }
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Carousel.js